module.exports = __webpack_public_path__ + "static/media/mangaa_isometric.92167678.png";